module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/img/logo.png"),
      "width": "192"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h1', [_vm._v("Oops! Algo deu errado...")]), _vm._v(" "), (_vm.erro) ? _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.erro) + "\n  ")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "browser"
  }, [_c('div', {
    staticClass: "controls"
  }, [_c('i'), _vm._v(" "), _c('i'), _vm._v(" "), _c('i')]), _vm._v(" "), _c('div', {
    staticClass: "eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "mouth"
  }, [_c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  }), _vm._v(" "), _c('div', {
    staticClass: "lips"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76b7d6d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/template/500.vue
// module id = 1508
// module chunks = 45